import React from 'react'
import {
    Col,
    Grid,
    Row
} from 'react-flexbox-grid'
import Typography from '@material-ui/core/Typography'
import YouTube from 'react-youtube'
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';


export default class Highlights extends React.Component{
    render(){
	// TODO: convert tile layout to component
	var content = this.props.content ? this.props.content.edges : [];
	var margin = 8;
	return(
	    <div className="section dark textured">
		<Grid>
		    <Row>
			<Col xs={12} sm={10} smOffset={1} md={12} mdOffset={0} lg={12} xl={10} xlOffset={1}
				style={{marginTop: (margin * -1), marginBottom: (margin * -1)}}>
			    <Row>
				{content.map(function(item, index){
				     item = item.node;
				     return (
					 <Col xs={12} md={6}
					      style={{marginTop: margin, marginBottom: margin}}
					      key={index}>
					     <Card className="card"
						   elevation={24}
						   style={{height: '100%'}}>
						 <CardContent>
						     <h2 className="title">
							 {item.frontmatter.title}
						     </h2>
						     <div dangerouslySetInnerHTML={{__html: item.html}} />
						 </CardContent>
					     </Card>
					 </Col>
				     )
				 })}
			    </Row>
			</Col>
		    </Row>
		</Grid>
	    </div>
	)
    }
}



// WEBPACK FOOTER //
// ./src/components/splash/highlights/index.jsx